import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "charts" }

import { withDefaults, watch } from 'vue'
import useEcharts from '../hooks/use-echarts'
import { EChartsOption } from 'echarts'

// 定義props

export default _defineComponent({
  props: {
    options: { type: null, required: true },
    width: { type: String, required: false, default: '100%' },
    height: { type: String, required: false, default: '360px' }
  } as unknown as undefined,
  setup(__props: {
    options: EChartsOption
    width?: string
    height?: string
  }, { expose }) {

const props = __props


const { echartRef, setOptions, updateSize } = useEcharts(props.options)

watch(
  () => props.options,
  () => {
    setOptions(props.options)
  }
)

expose({
  updateSize
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: echartRef,
      style: _normalizeStyle({ height: __props.height, width: __props.width })
    }, null, 4)
  ]))
}
}

})